// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8fc5899c","977":"8e47a06b"}[chunkId] + ".chunk.js";
};